export const AttDisabledInstallationDates = [
  '09/01/2025',
  '10/12/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
  '12/24/2025',
  '12/25/2025',
  '12/31/2025',
  '01/01/2026',
  '01/19/2026',
];

export const CoxDisabledInstallationDates = [
  '09/01/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
  '12/24/2025',
  '12/25/2025',
  '12/31/2025',
  '01/01/2026',
  '01/19/2026',
];

export const SpectrumDisabledInstallationDates = [
  '07/04/2025',
  '07/05/2025',
  '09/01/2025',
  '09/02/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
  '12/24/2025',
  '12/25/2025',
  '12/29/2025',
  '12/30/2025',
  '12/31/2025',
  '01/01/2026',
  '01/19/2026',
];

export const XfinityDisabledInstallationDates = [
  '09/01/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
  '12/24/2025',
  '12/25/2025',
  '12/31/2025',
  '01/01/2026',
  '01/19/2026',
];
